import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
const RegisterCreate = ({ props, classes }) => {
    const navigate = useNavigate();
    const params = useParams();
    const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [code, setCode]= useState('');
  const [codeState, setCodeState]= useState(false)
  const [name, setName]= useState('');
  const [nameState, setNameState]= useState(false)
  const [size, setSize] =useState('');
  const [sizeState, setSizeState] = useState(false)
  const [leaf, setLeaf]= useState('');
  const [leafState, setLeafState]= useState(false)
  const [printing, setPrinting]= useState('');
  const [printingState, setPrintingState]= useState(false)
  const [orientation, setOrientation]= useState('');
  const [orientationState, setOrientationState]= useState(false)
  const [periodicity, setPriodicity]= useState('');
  const [periodictiyState, setPriodicityState]= useState(false)
  const [location, setLocation]= useState('');
  const [locationState, setLocationState]= useState(false)
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (name === "") {
        setNameState(true);
    } else {
        setNameState(false);
    }
    if (size === "") {
        setSizeState(true);
    } else {
        setSizeState(false);
    }
    if(code === ""){
      setCodeState(true)
    }else{
      setCodeState(false)
    }
    if (periodicity === "") {
        setPriodicityState(true);
    } else {
        setPriodicityState(false);
    }
   
    if (name && size && code && periodicity) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    if(params.RegisterMasterId){
    GetData();
    }
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.REGISTER_MASTER_GET_BY_ID + params.RegisterMasterId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setCode(result?.data?.code)
      setName(result?.data?.name)
      setSize(result?.data?.size)
      setLeaf(result?.data?.leafs)
      setPrinting(result?.data?.printing)
      setOrientation(result?.data?.textOrientation)
      setPriodicity(result?.data?.periodicity)
      setLocation(result?.data?.location)
    }
  };

  const updateRoleInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.REGISTER_MASTER_UPDATE + params?.RegisterMasterId,
      method: "PUT",
      authToken: authToken,
      data: {
        code: code,
        name: name,
        size: size,
        leafs: leaf,
        printing:printing,
        textOrientation: orientation,
        periodicity: periodicity,
        location:location,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      return "SUCCESS";
    }
  };
  const saveRoleInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.REGISTER_MASTER_CREATE,
      method: "POST",
      authToken: authToken,
      data: {
        code: code,
        name: name,
        size: size,
        leafs: leaf,
        printing:printing,
        textOrientation: orientation,
        periodicity: periodicity,
        location:location,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      return "SUCCESS";
    }
  };
const handleroleSubmit = async (event) => {
  if (isValidated()) {
    toastUpdate("", "", true);
    let status = "";
    if (params.RegisterMasterId) {
      status = await updateRoleInformation();
    } else {
      status = await saveRoleInformation();
    }
    if (status === "SUCCESS") {
      const msg = params.RegisterMasterId
        ? "Register master updated successfully!"
        : "Register master created successfully!";
        toastUpdate("Success", msg, true);
      setRedirectURL(`/coreservice/RegisterMaster`);
    }
  }
};
  const handlecancelrole = () => {
    navigate("/coreservice/RegisterMaster");
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={params.RegisterMasterId ? "Edit Register" : "Create Register"}
          button1=" Save"
          button2=" Cancel"
          button1click={handleroleSubmit}
          button2click={handlecancelrole}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Code"
              required
              error={codeState}
              id="lp_min_role"
              value={code || ""}
              setState={setCode}
              setError={setCodeState}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Name"
              required
              error={nameState}
              id="name"
              value={name || ""}
              setState={setName}
              setError={setNameState}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Size"
              required
              error={sizeState}
              id="size"
              value={size || ""}
              setState={setSize}
              setError={setSizeState}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Pages"
              required
              error={leafState}
              id="pages"
              value={leaf || ""}
              setState={setLeaf}
              setError={setLeafState}
            />
          </Grid>
  
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Printing"
              required
              error={printingState}
              id="printing"
              value={printing || ""}
              setState={setPrinting}
              setError={setPrintingState}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="TextOrientation"
              required
              error={orientationState}
              id="orientation"
              value={orientation || ""}
              setState={setOrientation}
              setError={setOrientationState}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Periodicity"
              required
              error={periodictiyState}
              id="periodicity"
              value={periodicity || ""}
              setState={setPriodicity}
              setError={setPriodicityState}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Location"
              required
              error={locationState}
              id="location"
              value={location || ""}
              setState={setLocation}
              setError={setLocationState}
            />
          </Grid>
        </Grid>
      </Grid>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default RegisterCreate;
